module.exports = __webpack_public_path__ + "media/images/step-circle-ead98f965a8a08b438a12e993b75fff9.svg";